import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Drawer, Icon, Form, Input, InputNumber, Tooltip, notification, Upload } from "antd";
import axios from "axios";

const { TextArea } = Input;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const Dragger = Upload.Dragger;

const DrawerAlterarNota = ({ notaId, visible, onClose, atualizar, form }) => {
    const [nota, setNota] = useState("");
    const [motivo, setMotivo] = useState("");
    const [iconLoading, setIconLoading] = useState(false);
    //UPLOAD
    const [fileList, setFileList] = useState([]);
    const [docGerado, setDocGerado] = useState(undefined);

    const { getFieldDecorator } = form;

    const alterar = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                setIconLoading(true);

                var item = new FormData();
                item.append("id", notaId);
                if (nota) item.append("nota", nota);
                if (motivo) item.append("motivo", motivo);
                if (fileList.length > 0) item.append("anexo", fileList[0]);

                axios({
                    method: "put",
                    url: "/api/aproveitamento/alterar-nota",
                    data: item
                })
                    .then(response => {
                        openNotificationWithIcon("success", "Sucesso", "Registo alterado");
                        setIconLoading(false);
                        atualizar();
                    })
                    .catch(error => {
                        openNotificationWithIcon("error", "Erro", error.response.data);
                        setIconLoading(false);
                    });
            }
        });
    };

    const afterVisibleChange = aberto => {
        if (!aberto) {
            form.resetFields();
            setNota("");
            setMotivo("");
            setFileList([]);
            setDocGerado(undefined);
        }
    };

    const validarFormatoFicheiro = formato => {
        var formatos = ["pdf"];
        var valido = false;
        for (var i = 0; i < formatos.length; i++) {
            if (formato.toLowerCase() === formatos[i]) {
                valido = true;
                break;
            }
        }
        return valido;
    };

    const validar = (rule, value, callback) => {
        if (value.file) {
            if (value.file.size > 26214400) callback("Limite de 25 MB por upload!");
            if (!validarFormatoFicheiro(value.file.name.split(".").pop().toLowerCase()) && value.file.status !== "removed")
                callback("Ficheiro com formato inválido!");
        }

        callback();
    };

    const download = () => {
        const link = document.createElement("a");
        link.href = docGerado?.url;
        link.setAttribute("download", docGerado?.nome);

        document.body.appendChild(link);

        link.click();

        link.parentNode.removeChild(link);
    };

    const excluirDoc = () => {
        setFileList([]);
        setDocGerado(undefined);
    };

    const props = {
        accept: ".pdf",
        multiple: false,
        onRemove: file => {
            form.resetFields("ficheiro");
            setFileList(fileList => {
                const index = fileList.indexOf(file);
                const newFileList = fileList.slice();
                newFileList.splice(index, 1);

                return newFileList;
            });
        },
        defaultFileList: fileList,
        beforeUpload: file => {
            setFileList([file]);

            const blob = new Blob([file]);
            const fileUrl = URL.createObjectURL(blob);
            setDocGerado({
                nome: file.name,
                url: fileUrl
            });

            return false;
        },
        fileList
    };

    useEffect(() => {
        form.resetFields();
    }, [notaId]);

    return (
        <Drawer
            className="drawer-add-cursos"
            width={720}
            onClose={onClose}
            visible={visible}
            style={{
                overflow: "auto",
                height: "calc(100% - 108px)",
                paddingBottom: "108px"
            }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-info">
                <Form className="form-categorias listagem-avaliacoes" layout="horizontal">
                    <div className="bloco">
                        <Form.Item label="Nota">
                            {getFieldDecorator("nota", {
                                initialValue: nota
                            })(<InputNumber name="nota" onChange={value => setNota(value)} />)}
                        </Form.Item>
                        <Form.Item label="Motivo">
                            {getFieldDecorator("motivo", {
                                initialValue: motivo
                            })(<TextArea name="motivo" onChange={e => setMotivo(e.target.value)} rows={4} style={{ height: 100 }} />)}
                        </Form.Item>
                        <Form.Item>
                            <div className="anexos">
                                {getFieldDecorator("ficheiro", {
                                    rules: [
                                        {
                                            validator: validar
                                        }
                                    ],
                                    initialValue: fileList
                                })(
                                    <Dragger {...props} disabled={docGerado} showUploadList={false}>
                                        <p className="ant-upload-drag-icon">
                                            <i className="fas fa-upload" />
                                        </p>
                                        <p className="ant-upload-text">
                                            Adicionar anexo
                                            <Tooltip title="Formatos válidos: .pdf">
                                                <Icon type="question-circle-o" />
                                            </Tooltip>
                                        </p>
                                        <p className="ant-upload-hint">Limite de 25MB por upload</p>
                                    </Dragger>
                                )}
                            </div>
                            {docGerado && (
                                <div className="bloco">
                                    <div className="lista-videos">
                                        <div className="item-video">
                                            <span className="video-titulo">{docGerado.nome}</span>
                                            <div className="video-controlos">
                                                <Link to="#" className="botao-icon-download" title="Descarregar" onClick={download}>
                                                    <Icon type="download" />
                                                </Link>
                                                <Link to="#" className="botao-icon-excluir" title="Excluir" onClick={excluirDoc}>
                                                    <Icon type="delete" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Form.Item>
                    </div>
                </Form>
            </div>
            <div className="ant-drawer-footer">
                <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                    Voltar
                </button>
                <button className="botao-principal" onClick={alterar} disabled={iconLoading} type="primary">
                    {iconLoading ? <Icon type="loading" /> : null}
                    Salvar
                </button>
            </div>
        </Drawer>
    );
};

const FormDrawerAlterarNota = Form.create({ name: "drawer-alterar-nota" })(DrawerAlterarNota);

export default FormDrawerAlterarNota;
